import React, { useState, useEffect } from "react";
import { Button, Icon, Label, List, Table } from "semantic-ui-react";
import Aos from "aos";
import "aos/dist/aos.css";
import Papa from "papaparse";

import bioCsv from "../datas/zh/bio.csv";
import "../Css/BioTable.css";
import "../Css/Animations.css";
import { currentLang } from "./lang";
import FileReader_tr from "../Components/FileReader_tr";
function BioFileReader() {
  const [data, setData] = useState([]);
  const [renderData,setRenderData]=useState([]);
  
  const [isReady, setIsReady] = useState(false);
  var counter = 0;
  useEffect(() => {
    var path = "datas/" + currentLang + "/bio.csv"; //注意是public 資料夾
    console.log(currentLang);

    GetData(path).then((res) => {
      console.log(res);
      setData(res);
      const _renderData = [];
      for (var i = 0; i < res.data.length-1; i++) {
        _renderData.push(<FileReader_tr item={res.data[i]}></FileReader_tr>);
      }
      setRenderData(_renderData);
      setIsReady(true);
    });

    Aos.init();
    Aos.refresh();
  }, []);
  if (!isReady) {
    return <>Loading</>;
  } else
    return (
      <>
        <table className="bio-table">
          <tbody>{ renderData } </tbody>
        </table>
      </>
    );
}

export default BioFileReader;

async function GetData(path) {
  var config = {
    quotes: false, //or array of booleans
    quoteChar: '"',
    escapeChar: '"',
    delimiter: "\t",
    header: false,
    newline: "\r\n",
    skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
    columns: null, //or array of strings
  };

  const data = Papa.parse(await fetchCsv(path), config);
  console.log(data);
  return data;
}
async function fetchCsv(path) {
  const response = await fetch(path);
  const reader = response.body.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder("utf-8");
  const csv = await decoder.decode(result.value);
  //console.log("csv", csv);
  return csv;
}

export const ReadText = async (path) => {
  return await fetch(path)
    .then((r) => r.text())
    .then((text) => {
      //console.log(text);
      return text;
    });
};
